import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { BloquearPantallaModule } from '../../bloquear-pantalla/bloquear-pantalla.module';
import { CalificacionGrupoRoutingModule } from './calificacion-grupo-routing.module';
import { PaginacionModule } from '../../parcial/paginacion/paginacion.module';

import { PipesModule }             from '../../pipes/pipes.module';
import { CalificacionGrupoComponent } from './formulario/formulario.component';
import { CalificacionReprobadosComponent } from './reprobados/reprobados.component';

import { AuthService } from '../../auth.service';

import { MenuModule } from '../../menu/menu.module';
import { ParcialModule } from '../../parcial/parcial.module';

//crud
import { CrudService } from '../../crud/crud.service';
import { CrudModule } from '../../crud/crud.module';
//fin crud

import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { NgSelect2Module } from "ng-select2";
import { MonitorReprobadosComponent } from './monitor-reprobados/monitor-reprobados.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CalificacionGrupoRoutingModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    PaginacionModule,
    PipesModule,
    MenuModule,
    ParcialModule,
    CrudModule,
    NguiAutoCompleteModule,
    NgSelect2Module
  ],
  declarations: [CalificacionGrupoComponent, CalificacionReprobadosComponent, MonitorReprobadosComponent],
  providers: [AuthService, CrudService]
})
export class CalificacionGrupoModule {}
